<template>
  <div class="modifyPassword subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" :is-sub-page="true" title="修改密码" callbackFun="goBack" isReturn="false"></Header>
    <div class="info-block">
      <div class="input-block" style="margin-top:2px">
        <span class="prepend-style">原密码</span>
        <cube-input placeholder='请输入原密码' v-model="oldPassword" class="input" ></cube-input>
      </div>
      <div class="input-block" style="margin-top:2px">
        <span class="prepend-style">新密码</span>
        <cube-input placeholder='6-16位数字、字母组合' v-model="newPassword" class="input" ></cube-input>
      </div>
      <div class="input-block" style="margin-top:2px">
        <span class="prepend-style">确认密码</span>
        <cube-input placeholder='请再次输入新密码' v-model="confirmPassword" class="input" ></cube-input>
      </div>
    </div>
    <!--<div v-if="$route.query.platform === 'mini'" class="fixed-button">-->
    <div class="fixed-button">
      <div class="conversion-button safe-padding" @click="headGoBack">确认修改</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { updatePassword } from '@/api/user'

export default {
  name: '',
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  components: {
    Header
  },
  methods: {
    headGoBack () {
      if (this.newPassword !== this.confirmPassword) {
        this.$createToast({
          type: 'alert',
          time: 1000,
          txt: '密码不一致'
        }).show()
        return
      }
      updatePassword({
        'oldPassword': this.oldPassword,
        'newPassword': this.newPassword
      }).then((res) => {
        this.$createToast({
          txt: '提交成功',
          type: 'txt'
        }).show()
      })
    }

  }
}
</script>

<style lang="stylus" scoped>
.modifyPassword
  .prepend-style
    margin-left 20px;
    font-size 17px;
    color #545454;
    display flex;
    align-items center;
    font-weight:400;
  .input-block
    height 50px;
    display flex;
    justify-content space-between;
    background-color #FFFFFF;
    margin-top 5px;
    .input
      width:261px;
      position:static;
      font-weight:400;
      color:rgba(84,84,84,1);
      font-size:17px;
.fixed-button
  position: fixed;
  bottom: 0px;
  height: 49px;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #545454;
  .conversion-button
    background-color: #662C85;
    height: 49px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 17px;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
